import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=f95f9244&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=ts"
export * from "./Stock.vue?vue&type=script&lang=ts"
import style0 from "./Stock.vue?vue&type=style&index=0&id=f95f9244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95f9244",
  null
  
)

export default component.exports